import React, { useEffect } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box, Button, Grid, Stack, TextField } from '@mui/material';
import DashboardCards from './DashboardCards';
import AnchorTemporaryDrawer from './Drawer';
import DraggableFloatingButton from './Float';
import { Icon } from '@iconify/react';
import DetailView from './DetailView';
import MotionWrapper from '../../../components/MotionWrapper';
import ChartFin from './Chart/FinChart';
import { useDispatch, useSelector } from 'react-redux';
import { getFinDashboard, getDetailDash } from '../../../redux/features/financeSlice';
import Loader3D from '../../../components/Loader/Loader3D';
import { savePaginationData } from '../../../redux/features/globalDatagridSlice';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import useResponsive from '../../../Hooks/useResponsive';

const FeeForcasting = () => {
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(dayjs());
  const [selected, setSelected] = React.useState(null);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { finDashData, loading, finDetailDashData } = useSelector((state) => state.finance);
  const [currencyType, setCurrencyType] = React.useState(1);
  const [batch, setBatch] = React.useState(false);

  const handleBatch = (event) => {
    setBatch(event.target.value);
  };

  const handleChange = (event) => {
    setCurrencyType(event.target.value);
  };

  useEffect(() => {
    if (value) {
      const data = {
        currency: currencyType,
        date: dayjs(value).format('YYYY-MM'),
        batchStatus: batch,
      };
      dispatch(getFinDashboard(data));
    }
  }, [dispatch, value, currencyType, batch]);
  const data = {
    page: pageNum,
    limit: gridSize,
  };
  useEffect(() => {
    if (selected) {
      const datas = {
        ...data,
        date: dayjs(value).format('YYYY-MM'),
        search: search,
        projectId: selected.project_id,
        batchStatus: batch,
        currency: currencyType,
      };
      if (data.limit && data.page) {
        dispatch(getDetailDash(datas));
      }
    }
  }, [pageNum, gridSize, search, selected]);
  useEffect(() => {
    dispatch(savePaginationData({ ...paginationData, pageNum: 1 }));
  }, [search]);

  // useEffect(() => {
  //   if (selected) {
  //     const data = {
  //       projectId: selected.project_id,
  //       date: dayjs(value).format("YYYY-MM"),
  //     };
  //     dispatch(getDetailDash(data));
  //   }
  // }, [dispatch, selected, value]);

  const [state, setState] = React.useState({
    right: false,
  });
  const handleClick = (e, item) => {
    setSelected(item);
  };
  const handleFloatbtn = () => {
    setState({ right: true });
  };
  const handleClear = () => {
    setSelected(null);
  };

  return (
    <GlobalWrapper
      title={`Fee Forecasting ${selected ? `(${selected.project_name})` : ''}`}
      actions={
        <>
          {selected ? (
            <Stack direction={'row'} spacing={2}>
              <Button
                size="small"
                onClick={handleClear}
                sx={{
                  background: 'linear-gradient(to right, #702dff, black, black)',
                  color: 'white',
                  borderRadius: 3,
                }}
              >
                <Icon icon="lets-icons:back" width="24" height="24" /> Back
              </Button>
              <DraggableFloatingButton handleClick={handleFloatbtn} />
            </Stack>
          ) : null}
          {/* {selected ? (
            <DraggableFloatingButton handleClick={handleFloatbtn} />
          ) : null} */}
        </>
      }
    >
      {/* ---------------------------------------------------------- */}
      {selected ? null : (
        <MotionWrapper directions={'left'} delay={0.5}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Stack direction={smUp ? 'row' : 'column'} spacing={2}>
              <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="From Date"
                    value={value}
                    views={['year', 'month']}
                    onChange={(newValue) => setValue(newValue)}
                    slotProps={{
                      textField: {
                        sx: {
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '40px',
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ width: 200 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Currency Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={currencyType}
                    label="Currency Type"
                    sx={{
                      borderRadius: '30px',
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderRadius: '30px',
                      },
                    }}
                    onChange={handleChange}
                  >
                    <MenuItem value={1}>INR</MenuItem>
                    <MenuItem value={2}>AED</MenuItem>
                    <MenuItem value={3}>AED to INR</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              <Box sx={{ width: 200 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={batch}
                    label="Type"
                    sx={{
                      borderRadius: '30px',
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderRadius: '30px',
                      },
                    }}
                    onChange={handleBatch}
                  >
                    <MenuItem value={false}>ONE TO ONE</MenuItem>
                    <MenuItem value={true}>BATCH</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Stack>
          </Box>
        </MotionWrapper>
      )}

      {/* ------------------------------------------------------------------------------------ */}
      {selected ? (
        <DetailView currency={currencyType} selected={selected} date={value} batch={batch} />
      ) : (
        <Box pt={1}>
          {loading ? (
            <Loader3D />
          ) : (
            <>
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                {finDashData?.map((item, index) => (
                  <Grid item xs={12} sm={4} md={4} key={item.project_id}>
                    <MotionWrapper directions={'right'} delay={0.5}>
                      <DashboardCards handleClick={(e) => handleClick(e, item)} data={item} selected={selected} />
                    </MotionWrapper>
                  </Grid>
                ))}
                {/* <Grid item xs={12} sm={4} md={4}> */}

                {/* </Grid> */}
              </Grid>
              {/* <Box pt={2}>
                <MotionWrapper directions={"right"} delay={0.5}>
                  <ChartFin />
                </MotionWrapper>
              </Box> */}
            </>
          )}
        </Box>
      )}

      {/* ------------------------------------------------------------------------------------ */}
      <AnchorTemporaryDrawer
        state={state}
        setState={setState}
        setSelected={setSelected}
        selected={selected}
        data={data}
      />
    </GlobalWrapper>
  );
};

export default FeeForcasting;
